var _rect, _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DEF1EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 19,
    r: 4,
    fill: "#54BB9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16C19.3431 16 18 17.3431 18 19C18 20.6569 19.3431 22 21 22C22.6569 22 24 20.6569 24 19C24 17.3431 22.6569 16 21 16ZM16 19C16 16.2386 18.2386 14 21 14C23.7614 14 26 16.2386 26 19C26 21.7614 23.7614 24 21 24C18.2386 24 16 21.7614 16 19Z",
    fill: "#161717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 28C17.3431 28 16 29.3431 16 31V33C16 33.5523 15.5523 34 15 34C14.4477 34 14 33.5523 14 33V31C14 28.2386 16.2386 26 19 26H23C25.7614 26 28 28.2386 28 31V33C28 33.5523 27.5523 34 27 34C26.4477 34 26 33.5523 26 33V31C26 29.3431 24.6569 28 23 28H19Z",
    fill: "#161717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0312 14.882C27.1682 14.3469 27.713 14.0243 28.248 14.1613C30.4604 14.7277 32.0078 16.7212 32.0078 19.005C32.0078 21.2888 30.4604 23.2823 28.248 23.8487C27.713 23.9857 27.1682 23.6631 27.0312 23.128C26.8943 22.593 27.2169 22.0482 27.752 21.9113C29.0794 21.5714 30.0078 20.3753 30.0078 19.005C30.0078 17.6347 29.0794 16.4386 27.752 16.0988C27.2169 15.9618 26.8943 15.417 27.0312 14.882Z",
    fill: "#161717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0317 26.9C29.1698 26.3653 29.7152 26.0437 30.25 26.1817C32.4473 26.749 33.9869 28.725 34 30.9942L34 31L34 33C34 33.5523 33.5523 34 33 34C32.4477 34 32 33.5523 32 33V31.0031C31.991 29.6426 31.0675 28.4584 29.75 28.1182C29.2153 27.9802 28.8937 27.4348 29.0317 26.9Z",
    fill: "#161717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.56ab31687733299cb6c5b6608f1e22d2.svg";
export { ForwardRef as ReactComponent };